import config from '../config'
import http from '../http'

export default {
	getBanedSeller:async function(payload) {
		const res = await http({
			url: config.GET_BANED_SELLERS,
			method: 'post',
			data: {
			...payload,
			},
		})
		return res.data
	},
	delBanedSeller:async function(payload) {
		const res = await http({
			url: config.DEL_BANED_SELLERS,
			method: 'post',
			data: {
			...payload,
			},
		})
		return res.data
	},
	addBanedSeller:async function(payload) {
		const res = await http({
			url: config.ADD_BANED_SELLERS,
			method: 'post',
			data: {
			...payload,
			},
		})
		return res.data
	},
	getTiktopShopUrl:async function(payload) {
		const res = await http({
			url: config.GET_TIKTOK_SHOP_URL,
			method: 'get',
			data: {
			...payload,
			},
		})
		return res.data
	},
	getTiktopShopUrlEn:async function(payload) {
		const res = await http({
			url: config.GET_TIKTOK_SHOP_URL_EN,
			method: 'get',
			data: {
			...payload,
			},
		})
		return res.data
	},
	getTiktokUSShopUrlCustom:async function(payload) {
		const res = await http({
			url: config.GET_TIKTOK_SHOP_URL_CUSTOM,
			method: 'get',
			data: {
			...payload,
			},
		})
		return res.data
	},
	//加盟商仓库扣减用户积分
	deductionPoints:async function(payload) {
		const res = await http({
			url: config.INTEGRAL_DEDUCT,
			method: 'post',
			data: {
			...payload,
			},
		})
		return res.data
	},
	withDraw:async function(payload) {
		const res = await http({
			url: config.DEDUCT_INTEGRATION,
			method: 'post',
			data: {
			...payload,
			},
		})
		return res.data
	},
	getParnetUrl:async function(payload) {
		const res = await http({
			url: config.GET_SHOPEEPARNET_SHOP,
			method: 'get',
			data: {
			...payload,
			},
		})
		return res.data
	},
	
	getDXSAccount: async function(payload) {
		const res = await http({
			url: config.GET_ACCONT_DXS,
			method: 'post',
			data: {
			...payload,
			},
		})
		return res.data
	},

	relevanceWeanalyUser:async function(payload) {
		const res = await http({
			url: config.RELEVANCE_WEANALYUSER,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	getShopAddress:async function(payload) {
		const res = await http({
			url: config.GET_SHOPACCESS,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getshopifyurl:async function(payload) {
		const res = await http({
			url: config.GET_SHOPIFY_URL,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	bindShopify:async function(payload) {
		const res = await http({
			url: config.BIND_SHOPIFY,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	
	getDistributionStore:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GET_DISTRIBUTION_STORE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	sellerAddPrivateStore:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_ADD_PRIVATE_STORE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	

	addDistributionStore:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_CREATE_DISTRIBUTION_STORE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getPrivateStoreAccount:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GET_DISTRIBUTION_STORE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	updateStoreUsed:async function(payload) {
		const res = await http({
			url: config.UPDATA_STORE_USED,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	updateStoreUsed:async function(payload) {
		const res = await http({
			url: config.UPDATA_STORE_USED,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	bindLeagueStore:async function(payload) {
		const res = await http({
			url: config.BIND_LEAGUE_STORE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	addLeagueStore:async function(payload) {
		const res = await http({
			url: config.ADD_LEAGUE_STORE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	deleteSellerDiscount:async function(payload) {
		const res = await http({
			url: config.DELTE_SELLER_DISCOUNT,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getSellerDiscount:async function(payload) {
		const res = await http({
			url: config.GET_SELLER_DISCOUNT,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	setSellerDiscount:async function(payload) {
		const res = await http({
			url: config.SET_SELLER_DISCOUNT,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//判断新建的子仓名称是否已存在
	checkChildrenStore:async function(payload) {
		const res = await http({
			url: config.CHECK_EXIST_CHILDREN_STORE,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},

	//判断私有仓是否已存在
	checkPrivateStore:async function(payload) {
		const res = await http({
			url: config.CHECK_EXIST_PRIVATE_STORE,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},
	mandatorBind:async function(payload) {
		const res = await http({
			url: config.BAND_SELLERID_AND_SHORID,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getUserInfo:async function(payload) {
		const res = await http({
			url: config.GET_USER_INFO,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取仓库的扣费信息
	setSecPws:async function(payload) {
		const res = await http({
			url: config.OPEN_SECNOND_PWS,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取仓库的扣费信息
	getStoreChargeOrder:async function(payload) {
		const res = await http({
			url: config.GET_CHARGE_ORDER,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取私有仓
	getSellerPrivateStore:async function(payload) {
		const res = await http({
			url: config.GET_SELLER_PRIVATESTORE,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},
	
	//新建私有仓帐号
	createPrivateStore:async function(payload) {
		const res = await http({
			url: config.PRIVATE_STORE_REGISTER,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	
	//修改二次密码
		resetSecondyPassword:async function(payload) {
		const res = await http({
			url: config.RESET_SECONDARYT_PASSWORD,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//验证二次密码
	verifySecondyPassword:async function(payload) {
 	const res = await http({
 		url: config.VERIFY_SECONDARYT_PASSWORD,
 		method: 'get',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },
	//放弃索赔
	giveUpClaim:async function(payload) {
 	const res = await http({
 		url: config.GIVE_UP_CLAIM,
 		method: 'post',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },
	//确认索赔 
	auditReturn:async function(payload) {
 	const res = await http({
 		url: config.AUDIT_RETURN,
 		method: 'post',
 		data: payload
 	})
 	return res.data
 },
	//获取商店可索赔的订单
	getReturnOrder:async function(payload) {
 	const res = await http({
 		url: config.GET_RETURN_ORDER,
 		method: 'post',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },
	//获取当前帐号下所有的仓库
	getUserStock:async function(payload) {
 	const res = await http({
 		url: config.GET_SEARCH_USER_STORE,
 		method: 'get',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },
 //获取仓库帐号所有的仓库
 getAllstore: async function(payload) {
 	const res = await http({
 		url: config.GET_ALLSTORE_IN_STOREUSER,
 		method: 'get',
 		data: {
 			userId: payload
 		}
 	})
 	return res.data
 },
 //获取系统内所有的仓库
 getAllstoreALL: async function(payload) {
 	const res = await http({
 		url: config.GET_ALLSTORE_IN_SYSTEM,
 		method: 'get',
		data:{
			...payload
		}
 	
 	})
 	return res.data
 },
 //卖家帐号绑定仓库
 sellerBindStore:async function(payload) {
 	const res = await http({
 		url: config.BIND_STORE_BY_SELLER,
 		method: 'post',
		data:{
			...payload
		}
 	
 	})
 	return res.data
 },
 //店铺授权
 getShopAuthorization:async function(payload) {
 	const res = await http({
 		url: config.SHOP_AUTHORIZATION,
 		method: 'get',
 	})
 	return res.data
 },
 //解绑店铺
 unboundShop:async function(payload) {
 	const res = await http({
 		url: config.UNBOUND_SHOP,
 		method: 'post',
		data:{
			...payload
		}
 	})
 	return res.data
 },
 //解绑卖家帐号下的仓库
 unboundStore:async function(payload) {
 	const res = await http({
 		url: config.UNBOUND_STORE,
 		method: 'post',
		data:{
			...payload
		}
 	})
 	return res.data
 },
 
 //获取LAZADA授权网址
 getlazadaAuthorizationUrl:async function(payload) {
 	const res = await http({
 		url: config.GET_LAZADA_AUTHORIZATION_INFO,
 		method: 'get',
 		data:{
 			...payload
 		}
 	})
 	return res.data
 },
 
 //获取已经绑定的lazada商店
 getLazadaShop:async function(payload) {
 	const res = await http({
 		url: config.GET_LAZADA_SHOP,
 		method: 'get',
 		data:{
 			...payload
 		}
 	})
 	return res.data
 },
 //删除仓库
 deleteWarehouse:async function(payload) {
 	const res = await http({
 		url: config.DELE_STORE,
 		method: 'post',
 		data:{
 			...payload
 		}
 	})
 	return res.data
 },
 //获取商店的销售情况 
 getShopSale:async function(payload) {
 	const res = await http({
 		url: config.GET_SHOP_SALES,
 		method: 'post',
 		data:{
 			...payload
 		}
 	})
 	return res.data
 },
 //获取仓库的销售情况
 getStoreSale:async function(payload) {
	
 	const res = await http({
 		url: config.GET_STORE_SALSE_INFO,
 		method: 'post',
 		data:{
 			...payload
 		},
 	})
 	return res.data
 },
 //获取仓库货值
 getCargovalueStore:async function(payload) {
 	const res = await http({
 		url: config.GET_CARGOVALUE_STORE,
 		method: 'get',
 		data:{
 			...payload
 		}
 	})
 	return res.data
 },
 getcurrencyall:async function(payload) {
	const res = await http({
			url: config.CURRENCYALL,
			method: 'post',
			data:{
				...payload
			}
		})
	return res.data
  },

  updatecurrency:async function(payload) {
	const res = await http({
			url: config.CURRENCYUPDATE,
			method: 'post',
			data:{
				...payload
			}
		})
	return res.data
  },

  getstoresta:async function(payload) {
	const res = await http({
			url: config.GETSTORESTA,
			method: 'post',
			data:{
				...payload
			}
		})
	return res.data
  },
  getshopsh:async function(payload) {
	const res = await http({
			url: config.GETSHOPSH,
			method: 'post',
			data:{
				...payload
			}
		})
	return res.data
  },
  getintegral:async function(payload) {
	const res = await http({
			url: config.GETINTEGRAL,
			method: 'post',
			data:{
				...payload
			}
		})
	return res.data
  },

  getunreadconunt:async function(payload) {
	const res = await http({
			url: config.UNREAD_COUNT,
			method: 'get',
			data:{
				...payload
			}
		})
	return res.data
  },
 
}
